<div mat-dialog-title>
  <h2>{{ 'upload_external_prescription_file_extension_text' | locale }}</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>

<mat-dialog-content [formGroup]="formGroup">
  <mat-label [isRequired]="name">{{ 'upload_external_prescription_name' | locale }}</mat-label>
  <mat-form-field>
    <input
      matInput
      type="text"
      [placeholder]="'upload_external_prescription_name_placeholder' | locale"
      formControlName="name"
      autocomplete="off"
    />
    <mat-error>{{ name | errorMessage }}</mat-error>
  </mat-form-field>

  <div class="attachment-container" #attachmentContainer>
    @for (attachment of attachments; track attachment) {
      <div class="attachment">
        <div class="item-icon">
          <mat-icon svgIcon="sheet"></mat-icon>
        </div>
        <div class="item-text-container">
          <p class="first">{{ attachment.externalFileName }}</p>
          <p class="second">{{ attachment.medicines?.[0]?.active | locale }}</p>
          <p class="third">{{ attachment.externalFileSize | fileSizeDecimal }}</p>
          @if (attachment.progress) {
            <mat-progress-bar mode="determinate" color="accent" [value]="attachment.progress"></mat-progress-bar>
          }
        </div>
        <div class="item-actions">
          <button mat-icon-button (click)="openDetail(attachment)" [disabled]="attachment.progress != null">
            <mat-icon svgIcon="visibility"></mat-icon>
          </button>
          <button
            mat-icon-button
            (click)="remove(attachment.id!)"
            [disabled]="attachment.progress != null || attachment.status !== prescriptionStatus.PENDING_EXTERNAL_SEND"
          >
            <mat-icon svgIcon="flat-trash-can"></mat-icon>
          </button>
        </div>
      </div>
    } @empty {
      <p class="not-files">{{ 'upload_external_prescription_empty' | locale }}</p>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <input #attachmentInput type="file" style="display: none" (change)="addFile($event)" [accept]="fileExtensions.PDF" />

  <button mat-flat-button (click)="attachmentInput.click()" color="primary" [disabled]="!name.value || name.value.length === 0">
    {{ (attachments?.length > 0 ? 'upload_external_prescription_button_other' : 'upload_external_prescription_button') | locale }}
  </button>
</mat-dialog-actions>
